<template>
  <div id="footer-container">
    <div id="footer-main">
      <div id="footer-top">
        <div id="sales">
          <h4 class="footer-titles">Central de Vendas</h4>
          <div>
            <img src="./phone.svg" />
            <h5>0800 777 1022</h5>
          </div>
          <div>
            <img src="./phone.svg" />
            <h5>4000 2901</h5>
          </div>
          <div id="phone-container">
            <div>
              <img src="./whatsapp.svg" />
              <h6>
                <a href="https://wa.me/5511981192574" target="_blank"
                  >WhatsApp
                </a>
              </h6>
            </div>
            <div>
              <h6>
                <a href="https://www.movemais.com" target="_blank"
                  >Visite-nos
                </a>
              </h6>
            </div>
          </div>
        </div>
        <div class="list-container">
          <h4 class="footer-titles">Políticas</h4>
          <ul>
            <li>
              <a
                href="/api/v2/archeion/downloadFileArcheion/termos-e-condicoes-gerais-movemais"
                target="_blank"
                >Termos e Condições
              </a>
            </li>
            <li>
              <a
                href="/api/v2/archeion/downloadFileArcheion/aviso-de-privacidade-movemais"
                target="_blank"
              >
                Aviso de Privacidade
              </a>
            </li>
            <li>
              <a
                href="/api/v2/archeion/downloadFileArcheion/politica-de-cookies-movemais"
                target="_blank"
              >
                Política de Cookies
              </a>
            </li>
            <li>
              <a
                href="/api/v2/archeion/downloadFileArcheion/politica-de-reembolso-movemais"
                target="_blank"
              >
                Política de Reembolso
              </a>
            </li>

            <li>
              <a
                href="/api/v2/archeion/downloadFileArcheion/regulamento-da-campanha-adesao-gratis-movemais-roadcard"
                target="_blank"
              >
                Regulamento da campanha
              </a>
            </li>
          </ul>
        </div>
        <div class="list-container">
          <h4 class="footer-titles">Compliance</h4>
          <ul>
            <li>
              <a
                href="/api/v2/archeion/downloadFileArcheion/codigo-de-conduta-movemais"
                target="_blank"
              >
                Código de Conduta
              </a>
            </li>
            <li>
              <a
                href="https://www.contatoseguro.com.br/movemais"
                target="_blank"
              >
                Canal de Ética
              </a>
            </li>
            <li>
              <a
                href="/api/v2/archeion/downloadFileArcheion/requisitos-pre-aprovacao-provedores-externos-movemais"
                target="_blank"
              >
                Requisitos Fornecedores
              </a>
            </li>
          </ul>
        </div>
        <div class="list-container">
          <h4 class="footer-titles">Dúvidas</h4>
          <ul>
            <li>
              <router-link :to="{ name: 'FAQ' }" class="scrollup">
                Perguntas Frequentes
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'guide' }" class="scrollup">
                Guia de Instalação do TAG
              </router-link>
            </li>
            <li>
              <a
                href="/api/v2/archeion/downloadFileArcheion/tabela-de-tarifas-movemais"
                target="_blank"
              >
                Tarifas Move Mais
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div id="footer-bottom">
        <div id="app-download" class="footer-bottom-container">
          <h4 class="footer-titles">Baixe nosso App</h4>
          <div>
            <a
              href="https://apps.apple.com/br/app/move-mais-ped%C3%A1gio-free-flow/id6747896915"
              target="_blank"
            >
              <img src="./appStore.svg" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.movemais.morfeu"
              target="_blank"
            >
              <img src="./googlePlay.svg" />
            </a>
          </div>
        </div>
        <div class="footer-bottom-container">
          <h4 id="social-media-container" class="footer-titles">
            Acompanhe-nos
          </h4>
          <div>
            <a href="https://www.facebook.com/MoveMais/" target="_blank">
              <img src="./facebook.svg" alt="Facebook" />
            </a>
            <a href="https://www.instagram.com/movemais/" target="_blank">
              <img src="./instagram.svg" alt="Instagram" />
            </a>
            <a
              href="https://www.linkedin.com/company/move-mais/"
              target="_blank"
            >
              <img src="./linkedin.svg" alt="LinkedIn" />
            </a>
            <a href="https://twitter.com/Move_Mais" target="_blank">
              <img src="./twitter.svg" alt="Twitter" />
            </a>
            <a href="https://www.youtube.com/user/movemais" target="_blank">
              <img src="./youtube.svg" alt="YouTube" />
            </a>
          </div>
        </div>
        <div class="footer-bottom-container">
          <h4 class="footer-titles">Certificado</h4>
          <img src="./sectigo-siteseal.svg" />
        </div>
        <div class="footer-bottom-container">
          <h4 class="footer-titles">Consumidor</h4>
          <a href="https://consumidor.gov.br" target="_blank">
            <img src="./consumidor.gov.svg"
          /></a>
        </div>
        <div class="footer-bottom-container">
          <h4 class="footer-titles">Reputação</h4>
          <div id="reputation-ra"></div>
        </div>
      </div>

      <div id="footer-text-container">
        <img src="./logo_Move_Mais_v3_contorno.svg" />
        <p>
          © 2023 Todos os direitos reservados. Av. Rodrigo Fernando Grillo, 207,
          Edifício Victoria Business, 20º andar - Araraquara-SP.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isMobile: false,
    };
  },
  name: "YourComponentName",
  mounted() {
    const script = document.createElement("script");
    script.src = "https://s3.amazonaws.com/raichu-beta/selos/bundle.js";
    script.id = "ra-embed-reputation";
    script.dataset.id = "ODIyNjU6bW92ZS1tYWlz";
    script.dataset.target = "reputation-ra";
    script.dataset.model = "2";
    document.head.appendChild(script);

    // saber se está em desktop ou mobile.
    if (window.innerWidth <= 769) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }

    // evento disparado toda vez que a tela muda de tamanho
    window.addEventListener("resize", () =>
      window.innerWidth <= 769
        ? (this.isMobile = true)
        : (this.isMobile = false)
    );
  },
};
</script>
<style>
/* #social-media-container {
        width: 4rem;
    } */
#app-download div img {
  width: 12rem;
}
.footer-bottom-container {
  margin-bottom: 2rem;
  padding: 2px;
}
#footer-bottom {
  padding: 12px;
}
#footer-top {
  display: flex;
  flex-direction: column;
  padding: 20px;
}
.list-container {
  margin-bottom: 2rem;
}
.list-container ul li::marker {
  color: #5d3b81;
}
.list-container ul li {
  color: #5d3b81;
  list-style-position: inside;
}
#phone-container {
  margin-top: 1rem;
}
#phone-container div {
  padding: 0.5rem 1rem;
  background-color: #e8f0fc;
  display: flex;
  border-radius: 8px;
  margin-right: 1.5rem;
}
#sales {
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
}
#sales div {
  display: flex;
  color: #5d3b81;
}
#sales div img {
  margin-right: 1.5rem;
}
.footer-titles {
  color: #1a293dd4;
  font-weight: bold;
}
#footer-container {
  width: 110vw;
  background-color: #f4f9ff;
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#footer-main {
  width: 99vw;
  padding: 3rem 0 1rem 0;
  background-color: #f4f9ff;
}
#footer-text-container {
  display: flex;
  flex-direction: column;
  margin-left: 12px;
}
@media (max-width: 600px) {
  #footer-text-container img {
    width: 50%;
  }
  #footer-bottom {
    padding: 12px;
  }
}
@media (min-width: 600px) {
  #footer-top {
    flex-direction: row;
    justify-content: space-between;
  }
  #footer-bottom {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-flow: wrap;
    padding: 12px;
  }
  #footer-main {
    width: 99vw;
    padding: 29px;
    background-color: F4F9FF;
  }
  #footer-text-container {
    flex-direction: row;
    align-items: center;
  }
  #footer-text-container img {
    margin-right: 1.5rem;
  }
  #footer-text-container p {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// footer.vue?6bbd014a